import * as types from "./actionTypes";

export const yotiFetchIframeUrl = (jobId) => ({
  type: types.YOTI_FETCH_IFRAME,
  payload: { jobId },
});

export const yotiSetUrl = (url) => {
  return {
    type: types.YOTI_SET_URL,
    payload: url,
  };
};
